import http from "../../services/http";

const getAllQuestionsApi = async (form_id) => {
  return await http("get", `v1/formularios_colaboradores/questoes/getAll/${form_id}`);
};

const getQuestionsByIdApi = async (id) => {
  return await http("get", `v1/formularios_colaboradores/questoes/get/${id}`);
};

const createQuestionsApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/questoes/create", data);
};

const updateQuestionsApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/questoes/update", data);
};

const deleteQuestionsApi = async (id) => {
  return await http("post", "v1/formularios_colaboradores/questoes/delete", { id: id });
};

export { deleteQuestionsApi, updateQuestionsApi, createQuestionsApi, getQuestionsByIdApi, getAllQuestionsApi };
